import { render } from "./DefenseOutpostFromNpc.vue?vue&type=template&id=0213d606&scoped=true"
import script from "./DefenseOutpostFromNpc.vue?vue&type=script&lang=js"
export * from "./DefenseOutpostFromNpc.vue?vue&type=script&lang=js"

import "./DefenseOutpostFromNpc.vue?vue&type=style&index=0&id=0213d606&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0213d606"]])

export default __exports__